// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { HTMLAttributes, useEffect, useRef, useState } from 'react';
import './styles.scss';

const rootClassName = 'component-fade-in-section';

interface FadeInSectionProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function FadeInSection(props: FadeInSectionProps) {
  const [show, setShow] = useState<boolean>(false);
  const domReference = useRef<any>();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setShow(entry.isIntersecting));
    });
    observer.observe(domReference.current);
  }, []);

  return (
    <div
      {...props}
      className={`${rootClassName} ${show ? 'is-visible' : ''}`}
      ref={domReference}
    >
      {props.children}
    </div>
  );
}
